<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-skill`]" width="1em" height="1em" v-bind="$attrs"><path d="M9.33557 0.79991C9.53306 0.549974 9.86742 0.452575 10.1683 0.557112C10.469 0.661753 10.6704 0.945117 10.6704 1.26353V6.37108H15.6824C15.9691 6.37108 16.2308 6.53491 16.3558 6.79295C16.4808 7.05108 16.4469 7.35792 16.269 7.58287L8.6643 17.1959C8.46671 17.4457 8.13234 17.5433 7.83154 17.4387C7.53089 17.334 7.32946 17.0507 7.32946 16.7323V11.6357H2.3175C2.03073 11.6357 1.76904 11.4719 1.64404 11.2139C1.51915 10.9558 1.55308 10.6489 1.73083 10.4239L9.33557 0.79991ZM3.86218 10.1394H8.07763C8.49063 10.1395 8.82561 10.4746 8.8258 10.8876V14.5801L14.1366 7.86742H9.92224C9.50921 7.86727 9.17411 7.5323 9.17407 7.11925V3.41685L3.86218 10.1394Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineSkill',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
